import React, { useState, useEffect } from 'react';

import moment from 'moment';

import { Modal, Radio } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

import RenderProfilePic from '../../../extras/RenderProfilePic';

const timeFormat = 'DD MMM YYYY hh:mm:ss a';

export default function ScoreDetailsModal({ params, isFirstScore }) {
  const [openModal, setOpenModal] = useState(false);
  const [feedbackObj, setFeedbackObj] = useState(null);
  const [isModal, setIsModal] = useState(false);

  let rating = [];
  let plaigarism = '';
  let feedbackText = '';
  let isIterateThroughRatingObj = false;

  const handleClose = () => {
    setOpenModal(false);
  };

  const isRevaluationRequested = params?.data?.reEvaluationRequested;

  useEffect(() => {
    if (isRevaluationRequested) {
      if (isFirstScore) {
        params?.data?.previousSolutions?.forEach((solution) => {
          if (solution.coachFeedback) setFeedbackObj(solution.coachFeedback);
        });
      } else {
        setFeedbackObj(params?.data?.coachFeedback);
      }
    } else {
      setFeedbackObj(params?.data?.coachFeedback);
    }
  }, []);

  useEffect(() => {
    const isModal = (() => {
      if (isRevaluationRequested && isFirstScore)
        return (
          params?.data?.previousCredits !== null &&
          params?.data?.previousCredits !== undefined &&
          feedbackObj !== null
        );

      return (
        params?.data?.credits !== null &&
        params?.data?.credits !== undefined &&
        feedbackObj !== null
      );
    })();
    setIsModal(isModal);
    if (isModal) {
      const allRubricsArr =
        params?.data?.project?.attributes?.project_category?.data?.attributes
          ?.rubrics;

      feedbackText = feedbackObj?.feedback;

      const rubricsValue = feedbackObj?.ratings;
      if (!allRubricsArr) return;
      for (let i = 0; i < allRubricsArr?.length; i++) {
        const rubricItem = allRubricsArr[i];
        const rubricItemKey = rubricItem.rubricKey;
        if (rubricsValue && rubricsValue[rubricItemKey]) {
          rubricItem.value = rubricsValue[rubricItemKey];
        } else {
          isIterateThroughRatingObj = true;
          break;
        }
      }

      if (feedbackObj?.plagiarisedSolution) {
        plaigarism = 'plagiarised';
      } else {
        plaigarism = 'self_written';
      }

      rating = allRubricsArr;
    }
  }, []);

  const getScore = () => {
    if (isRevaluationRequested) {
      if (isFirstScore) return params?.data?.previousCredits;
      else return params?.data?.credits;
    } else {
      if (isFirstScore) return params?.data?.credits;
      else return '-';
    }
  };

  return (
    <div>
      <div
        className='flex items-center h-full text-blue-600 cursor-pointer'
        onClick={() => {
          if (!isModal) return;
          setOpenModal(true);
        }}
      >
        {getScore()}
      </div>
      {isModal && (
        <Modal
          open={openModal}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <div className='relative overflow-y-auto h-5/6 top-2 md:top-10 m-auto bg-white  rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
            <div
              className='absolute right-2 top-2 cursor-pointer'
              onClick={handleClose}
            >
              X
            </div>
            <div className='flex flex-col'>
              <div className='flex mb-4'>
                {params?.data?.project?.attributes?.icon?.data?.attributes
                  ?.url ? (
                  <img
                    src={
                      params?.data?.project?.attributes?.icon?.data?.attributes
                        ?.url
                    }
                    className='w-16 h-16 rounded-full'
                  />
                ) : (
                  <RenderProfilePic
                    name={params?.data?.project?.attributes?.name}
                    thumbnail=''
                    size='3'
                  />
                )}

                <div className='flex-auto'>
                  <div className='mr-2 px-4 flex items-center gap-3'>
                    <div className='flex-auto'>
                      <h3 className='font-medium'>
                        {params?.data?.project?.attributes?.name}
                      </h3>

                      <span className='text-gray-600 text-opacity-80 text-sm'>
                        {
                          params?.data?.project?.attributes?.project_category
                            ?.data?.attributes?.name
                        }
                      </span>
                    </div>
                    <div>
                      <div className='text-gray-500 text-sm grow-0'>
                        Submitted on{' '}
                        {moment(params?.data?.submittedAt).format(timeFormat)}
                      </div>
                      {params?.data?.evaluatedAt && (
                        <div className='text-gray-500 text-sm grow-0'>
                          Evaluated on{' '}
                          {moment(params?.data?.evaluatedAt).format(timeFormat)}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='flex items-center px-4 mt-3 rounded w-max text-sm'>
                    <div className='font-medium mr-5'>By</div>
                    <RenderProfilePic
                      thumbnail={params?.data?.Students?.thumbnail}
                      name={params?.data?.Students?.firstName}
                      size={3}
                    />
                    <div className='ml-2'>{`${params?.data?.Students?.firstName} ${params?.data?.Students?.lastName}`}</div>
                  </div>
                </div>
              </div>
              <hr className='mb-4' />
              <div className='font-bold'>Ratings & Feedback</div>

              {isIterateThroughRatingObj
                ? feedbackObj.ratings &&
                  Object.keys(feedbackObj.ratings).map((objectKey, index) => (
                    <div className='flex mb-2' key={index}>
                      <div className='w-64 text-gray-400 text-sm'>
                        {objectKey}
                      </div>
                      <Rating
                        max={10}
                        readOnly={true}
                        name={objectKey}
                        value={feedbackObj.ratings[objectKey]}
                      />
                    </div>
                  ))
                : rating.map((rubricItem, index) => (
                    <div className='flex mb-2' key={index}>
                      <div className='w-64 text-gray-400 text-sm'>
                        {rubricItem.rubricName}
                      </div>
                      <Rating
                        max={10}
                        readOnly={true}
                        name={rubricItem.rubricName}
                        value={rubricItem.value}
                      />
                    </div>
                  ))}

              <hr className='mt-4 mb-4' />

              <div className='text-gray-400 text-sm'>Plaigarism</div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  disabled={true}
                  color='primary'
                  name='plaigarism'
                  value='self_written'
                  checked={plaigarism === 'self_written'}
                />
                <span className='text-sm font-normal opacity-60'>
                  Self-written submission
                </span>
              </div>
              <div className='flex items-center -mb-2 -ml-2'>
                <Radio
                  disabled={true}
                  color='primary'
                  name='plaigarism'
                  value='plagiarised'
                  checked={plaigarism === 'plagiarised'}
                />
                <span className='text-sm font-normal opacity-60'>
                  Plagiarised submission
                </span>
              </div>

              <div className='text-sm text-gray-400 mt-4'>Feedback</div>
              <textarea
                disabled={true}
                rows='4'
                className='w-full border border-gray-300 focus:outline-none focus:border-blue-c1 focus:ring-1 focus:ring-blue-c1 rounded-lg p-2'
                value={feedbackText}
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
